var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 3V7.875C10.0625 8.02418 10.0032 8.16726 9.89773 8.27275C9.79224 8.37824 9.64916 8.4375 9.49998 8.4375C9.3508 8.4375 9.20772 8.37824 9.10223 8.27275C8.99674 8.16726 8.93748 8.02418 8.93748 7.875V4.35937L3.89795 9.39797C3.79228 9.50364 3.64895 9.56301 3.49951 9.56301C3.35007 9.56301 3.20675 9.50364 3.10107 9.39797C2.9954 9.2923 2.93604 9.14897 2.93604 8.99953C2.93604 8.85009 2.9954 8.70677 3.10107 8.60109L8.1406 3.5625H4.62498C4.4758 3.5625 4.33272 3.50324 4.22723 3.39775C4.12174 3.29226 4.06248 3.14918 4.06248 3C4.06248 2.85082 4.12174 2.70774 4.22723 2.60225C4.33272 2.49676 4.4758 2.4375 4.62498 2.4375H9.49998C9.64916 2.4375 9.79224 2.49676 9.89773 2.60225C10.0032 2.70774 10.0625 2.85082 10.0625 3Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2ccf18c1574f76dfc005b990d1d451bb.svg";
export { ForwardRef as ReactComponent };